import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { HotlineClientDetailLayout, } from '@/feature/hotline/client/detail/component/HotlineClientDetailLayout';
import { hotlineClientDetailViewStyle } from '@/feature/hotline/client/detail/index/page/style';
import { HotlineDescriptionList, } from '@/feature/hotline/component/HotlineDescriptionList';
import { HOTLINE_DISCLOSES } from '@/feature/hotline/constant/disclose';
import { formatDateToText, formatDateToRangeText, } from '@/feature/hotline/util/formatDate';
/**
 * 匿名コンサルホットライン クライアント詳細（View 部分のみ）
 */
export const HotlineClientDetailView = (props) => {
    const { detailData, onSubmitAdviserModal } = props;
    const style = hotlineClientDetailViewStyle();
    /** 表示項目 */
    const items = useMemo(() => {
        var _a;
        return [
            {
                head: '相談希望日',
                value: formatDateToRangeText(detailData.interview_requested_from_at, detailData.interview_requested_to_at),
            },
            {
                head: '締切日',
                value: detailData.is_paused
                    ? '新規オファー停止'
                    : formatDateToText(detailData.request_deadline_at, true),
            },
            {
                head: '相談タイトル',
                value: detailData.title,
            },
            {
                head: '業界',
                value: detailData.industry,
            },
            {
                head: '企業名の開示',
                value: ((_a = HOTLINE_DISCLOSES.find(({ value }) => value === detailData.disclose)) === null || _a === void 0 ? void 0 : _a.label) || '-',
            },
            {
                head: '相談の背景',
                value: detailData.description,
            },
            {
                head: '期待するアドバイス',
                value: detailData.advice_request,
            },
        ];
    }, [detailData]);
    return (_jsx(HotlineClientDetailLayout, Object.assign({ activeStepIndex: 0, adminUser: detailData.admin_user, classNames: { childrenWrap: style.base() }, id: detailData.id, onSubmitAdviserModal: onSubmitAdviserModal, pageTitle: detailData.title }, { children: _jsx(HotlineDescriptionList, { items: items }) })));
};
